export async function getTimeZoneId(apiKey: string, lat, lng): Promise<string> {
  const timestamp = Math.floor(Date.now() / 1000);
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${apiKey}`
  );
  const data = await response.json();

  return data.timeZoneId;
}
